/**
 * Sanitizes admin-authored rich text before it reaches every signed-in
 * user's browser.
 *
 * The Description editor (RichTextEditor) is trusted at the point it is
 * WRITTEN — only an admin can save it (`home:edit`, server-enforced) — but
 * every signed-in user RENDERS it, on every visit to the home page. An admin
 * account being able to store a `<script>` that then runs in every OTHER
 * user's session is a bigger blast radius than "an admin typed something
 * odd", so this still strips anything that executes rather than assuming the
 * author is also the only reader.
 */

import DOMPurify from 'dompurify';

/** Tags/attributes the editor's own toolbar can actually produce, plus the
 *  legacy `<font>` markup some browsers still emit for size/colour commands. */
export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html ?? '', {
    ALLOWED_TAGS: [
      'p', 'br', 'div', 'span', 'font',
      'strong', 'b', 'em', 'i', 'u',
      'ul', 'ol', 'li',
      'a', 'img',
      'h1', 'h2', 'h3', 'h4', 'blockquote',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'style', 'color', 'size', 'face'],
  });
}
